import * as Sentry from '@sentry/react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const apiErrorHandler = (error: any) => {
  console.error(error);
  Sentry.captureException(error);
};
